import { ICommonProduct, IProduct } from "../products/products.interface";
import httpClient from "@/api/httpClient";
import { IWholesaleOrder } from "../wholesale/wholesale.interface";

export const getCustomerOrderService = async (
  id: string
): Promise<IWholesaleOrder> => {
  try {
    const response = await httpClient.get(`/v1/history/wholesale-order/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const addCustomOrderService = async (
  product: ICommonProduct
): Promise<IProduct> => {
  try {
    const response = await httpClient.post(
      "/v1/script/insert-wholesale-order",
      product
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const updateCustomOrderService = async (
  id: string,
  product: ICommonProduct
): Promise<IProduct> => {
  try {
    const response = await httpClient.patch(
      `/v1/script/update-wholesale-order/${id}`,
      product
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const deleteCustomOrderService = async (
  id: string
): Promise<IProduct> => {
  try {
    const response = await httpClient.delete(
      `/v1/script/delete-wholesale-order/${id}`
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};
